import React, { useCallback, useEffect, useState } from 'react';
import { WorkProfile } from '../../components/ScreenContainer/EsMyProfileContainer/WorkProfile';
import { useParams } from 'react-router-dom';
import { getTalentProfileDetails } from '../../redux/talentProfile/action';
import { useDispatchPromise } from '../../utils/AppUtils';
import { Loading } from '../../components/Loading/Loading';
import { IWorkProfile } from '../../types/global/helper';
import { isEmpty } from '../../utils/lodash';
import { MetaTags } from '../../components/Metatags/Metatags';
import { Container } from '@mui/material';
import { EmptySearchBlock } from '../../components/EsSidebar/EsSearch/EmptySearchBlock';
import { useAuth } from '../../module/AuthContext';

export const WorkProfilePage = () => {
    const { userName } = useParams();
    const [loading, setLoading] = useState(false);
    const [workProfile, setWorkProfile] = useState<IWorkProfile[]>([]);
    const { user } = useAuth();
    const dispatch = useDispatchPromise();
    const handleGetUserWorkProfile = useCallback(() => {
        setLoading(true);
        if (userName) {
            dispatch(getTalentProfileDetails(userName))
                .then(response => {
                    setWorkProfile(response as IWorkProfile[]);
                    setLoading(false);
                })
                .catch(e => {
                    setLoading(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userName]);

    useEffect(() => {
        handleGetUserWorkProfile();
    }, [handleGetUserWorkProfile]);

    if (loading && isEmpty(workProfile)) {
        return <Loading />;
    }

    if (isEmpty(workProfile) && !loading) {
        return (
            <MetaTags title={`Work Profile | ${userName || 'Loading...'}`} description={userName || ''}>
                <Container
                    disableGutters
                    sx={{
                        height: 'auto',
                        minHeight: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        ml: { xs: 0, sm: 10 },
                        width: { xs: '100%', sm: '85%', smMd: '90%', xl: '95%' },
                    }}>
                    <EmptySearchBlock title={`${userName} not found.`} subTitle="Please check the username" />
                </Container>
            </MetaTags>
        );
    }

    /** Get profile from param */
    return (
        <MetaTags title={`Work Profile | ${userName || 'Loading...'}`} description={userName || ''}>
            <WorkProfile
                isEditMode={false}
                external
                workProfile={workProfile}
                isPublicMode={workProfile[0].created_by?._id !== user?._id}
                userName={userName}
            />
        </MetaTags>
    );
};
